import { supabase } from '@/lib/supabase';
import type { TaskActivityRow } from '@/types/database.types';

export async function listActivity(taskId: string, limit = 50): Promise<TaskActivityRow[]> {
  const { data, error } = await supabase
    .from('task_activity')
    .select('*')
    .eq('task_id', taskId)
    .order('created_at', { ascending: false })
    .limit(limit);
  if (error) throw error;
  return data ?? [];
}
